<template>
    <div>
        <div>
            Add Investment Component
        </div>
       <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Back" type="secondary"/>
              <btn text="Add" type="primary" @click="addInvestment"/>
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer> 
    </div>
</template>

<script>
export default {
    name: "addNewInvestmentPopup",
    data() {
        return {
            
        };
    },
    methods: {
        addInvestment() {

        }        
    },
}
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";

</style>
